// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar-module--search--2wFNw","button":"SearchBar-module--button--30p-C","input":"SearchBar-module--input--2_bHt","searchIcon":"SearchBar-module--searchIcon--NgbZK"};